import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "./lib/auth";
import { useLanguage } from "./lib/i18n";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Tournaments from "./pages/Tournaments";
import TournamentDetail from "./pages/TournamentDetail";
import Players from "./pages/Players";
import PlayerDetail from "./pages/PlayerDetail";
import Decks from "./pages/Decks";
import DeckDetail from "./pages/DeckDetail";
import Leaderboard from "./pages/Leaderboard";
import AdminDashboard from "./pages/AdminDashboard";
import CreateTournament from "./pages/CreateTournament";
import Login from "./pages/Login";
import Register from "./pages/Register";
import MyProfile from "./pages/MyProfile";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import DeckBuilder from "./pages/DeckBuilder";
import Creators from "./pages/Creators";
import AuthCallback from "./pages/AuthCallback";

// Iter 41 — Emergent Google OAuth returns the user to
// `<origin>/#session_id=...`. Detect that synchronously during render
// (BEFORE any Route matches) so we never miss the fragment. Any route
// works as the redirect target; we prefer `/` so the deep-link path
// stays clean once AuthCallback replaces the hash.
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/tournaments" element={<Tournaments />} />
      <Route path="/tournaments/:id" element={<TournamentDetail />} />
      <Route path="/host" element={<CreateTournament />} />
      <Route path="/players" element={<Players />} />
      <Route path="/players/:id" element={<PlayerDetail />} />
      <Route path="/decks" element={<Decks />} />
      <Route path="/decks/:id" element={<DeckDetail />} />
      <Route path="/leaderboard" element={<Leaderboard />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/me" element={<MyProfile />} />
      <Route path="/deck-builder" element={<DeckBuilder />} />
      <Route path="/deck-builder/:id" element={<DeckBuilder />} />
      <Route path="/creators" element={<Creators />} />
      <Route path="/admin/login" element={<Navigate to="/login" replace />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  // Subscribe at the root so a language switch re-renders the entire tree;
  // the proxy in i18n.js then serves fresh translations to every component.
  useLanguage();
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <AppRouter />
        </Layout>
        <Toaster theme="dark" position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
